import React, { useContext, useEffect } from 'react';
import t from '~t';
import { Outlet, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { target } from '~target';

import SplitView, { Context } from '~co/screen/splitview';
import Main from '~co/screen/splitview/main';
import Sidebar from './sidebar';

// narrow popup (<=500px, same breakpoint as the drawer CSS): the sidebar opens
// as an overlay drawer that hides the section content — auto-close it on
// navigation so settings land on the section itself
function AutoCloseDrawer() {
  const location = useLocation();
  const { sidebar } = useContext(Context);

  useEffect(() => {
    if (target == 'extension' && window.innerWidth <= 500) sidebar.close();
  }, [location.pathname]);

  return null;
}

export default function PageSettingsLayout() {
  const hideFrame = navigator.userAgent.includes('RaindropMobile');

  return (
    <SplitView>
      <AutoCloseDrawer />
      <Helmet>
        <title>{t.s('settings')}</title>
      </Helmet>

      {!hideFrame && <Sidebar />}

      <Main className='overflow-auto'>
        <div className='mx-auto flex w-[16rem] max-w-full flex-1 flex-col px-[var(--padding-small)] pb-[var(--padding-medium)]'>
          <Outlet />
        </div>
      </Main>
    </SplitView>
  );
}
